require('../../../src/stylus/components/_grid.styl');

import Grid from './grid';

export default Grid('container');


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VGrid/VContainer.js
// module id = NUs8
// module chunks = 0